import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles({
  root: {
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgb(0,0,0,0.5)',
    zIndex: 4000
  },
  loading: {
    color: 'white',
    display: 'block',
    width: 240,
    position: 'absolute',
    top: 'calc(50% - 50px)',
    left: 'calc(50% - 100px)',
    textAlign: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: 20,
    backgroundColor: 'rgb(0,0,0,0.15)',
    borderRadius: 15,
    borderColor: '#229EEC',
    borderWidth: 2
  },
  login: {
    color: 'yellow',
    '&:hover': {
      color: 'white',
      textDecoration: 'none'
    }
  }
})

export {
  useStyles
}
